var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_456_2415)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_456_2415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8453 11.5451C21.9422 9.04199 19.9969 7.13418 18.0656 5.86855C16.0875 4.5748 14.0719 3.91387 12.0656 3.90918C12.0562 3.90918 12.0469 3.90918 12.0375 3.90918C10.0266 3.90918 7.99219 4.56543 6 5.86387C4.05469 7.1248 2.08594 9.0373 0.154688 11.5404C-0.0515625 11.8123 -0.0515625 12.1873 0.154688 12.4545C2.08594 14.9623 4.05469 16.8748 6 18.1357C7.99687 19.4342 10.0266 20.0904 12.0375 20.0904H12.0656C14.0719 20.0857 16.0922 19.4248 18.0656 18.1311C19.9969 16.8654 21.9375 14.9576 23.8453 12.4545C24.0516 12.1873 24.0516 11.8123 23.8453 11.5451ZM12.0609 18.5904C12.0516 18.5904 12.0422 18.5904 12.0375 18.5904C8.66719 18.5904 5.18906 16.3732 1.70156 11.9998C5.18906 7.62637 8.6625 5.40918 12.0375 5.40918H12.0609C15.4219 5.41855 18.8672 7.63574 22.2984 11.9998C18.8672 16.3639 15.4266 18.5811 12.0609 18.5904ZM12 7.3123C9.41719 7.3123 7.3125 9.41699 7.3125 11.9998C7.3125 14.5826 9.41719 16.6873 12 16.6873C14.5828 16.6873 16.6875 14.5826 16.6875 11.9998C16.6875 9.41699 14.5828 7.3123 12 7.3123ZM12 15.1873C10.2422 15.1873 8.8125 13.7576 8.8125 11.9998C8.8125 10.242 10.2422 8.8123 12 8.8123C13.7578 8.8123 15.1875 10.242 15.1875 11.9998C15.1875 13.7576 13.7578 15.1873 12 15.1873Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_456_2415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_456_2415"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibleIcon);
export default __webpack_public_path__ + "static/media/visible_icon.fc4cc705665748a0b5d45aa9259405de.svg";
export { ForwardRef as ReactComponent };